import { Box, Typography } from "@mui/material";
import { SentimentVeryDissatisfied } from "@mui/icons-material";

import { globalWordings } from "../data";

export const ErrorState = () => {
  const lang = window.location.pathname.split("/")[1] || "en";

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <SentimentVeryDissatisfied sx={{ fontSize: 48 }} />
      <Typography variant="bold" fontSize={20}>
        {globalWordings[lang]?.error}
      </Typography>
    </Box>
  );
};
